import React from 'react';

// English Privacy Policy section bodies — DRAFT translation pending legal
// review; the Italian version (privacy.it.jsx) is the binding one.
const privacyEn = {
  dataCollected: (
    <>
      We collect your account data (email, via Firebase Authentication), the content of your
      brainstorming sessions with the AI mentor, and — only if you explicitly choose to send one at the
      end of a session — a contact request (email and, optionally, a phone number if you provide it). If
      a business problem you are exploring clearly emerges during a session, an anonymous, summarized
      excerpt (never your name, never your company's name) may be shown, after manual review, in the
      "use cases" section of the home page.
    </>
  ),
  legalBasis: (
    <>
      The processing of account and session data is based on the performance of the service you
      requested. Sending a contact request is based on your explicit consent, given by ticking the
      consent box at the time of sending — you may choose not to send it at any time.
    </>
  ),
  retention: (
    <>
      Account and session data are retained for as long as your account remains active. Contact
      requests are retained for a maximum of 6 months, after which they are automatically deleted. Use
      cases published on the home page are anonymous from the outset and have no retention limit linked
      to you personally.
    </>
  ),
  thirdParties: (
    <>
      When you send a contact request, your name (if available) and your email are sent as an internal
      notification to Telegram, to let the team know that someone has asked to be contacted — your phone
      number, if provided, is NEVER sent to Telegram and remains only in our systems.
      <br /><br />
      <strong>Google Analytics 4.</strong> If you give consent via the cookie banner (the "Statistics"
      category), we use Google Analytics 4 (ID <code>G-FXG3L4ZPD9</code>) to collect statistics on site usage.
      The legal basis is your consent (Art. 6(1)(a) GDPR; Art. 122 of the Codice Privacy). Google Ireland Ltd /
      Google LLC process the data as processors on our behalf, with transfer of data to the United States
      under the EU-US Data Privacy Framework and, where applicable, Standard Contractual Clauses. You can
      withdraw consent at any time via the "Cookie preferences"
      link in the site's footer. For details (cookies used, duration), see the{' '}
      <a href="/cookie-policy">Cookie Policy</a>.
    </>
  ),
  yourRights: (
    <>
      You may request access to, correction of, or early deletion of your data by writing to{' '}
      <a href="mailto:info@fluel.it">info@fluel.it</a>.
    </>
  ),
};

export default privacyEn;
